'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastDialogKey = exports.getFirstDialogKey = exports.getDialogArgs = exports.initialState = undefined;

var _ShowDialogAction = require('./actions/ShowDialogAction');

var _HideDialogAction = require('./actions/HideDialogAction');

var _immutable = require('immutable');

// ordered map with key - dialogId and value - dialogArgs
var initialState = exports.initialState = (0, _immutable.OrderedMap)();

var dialogReducer = function dialogReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {
    case _ShowDialogAction.SHOW_DIALOG_ACTION:
      {
        return state.set(action.dialogId, action.args);
      }
    case _HideDialogAction.HIDE_DIALOG_ACTION:
      {
        return state.delete(action.dialogId);
      }
    default:
      {
        return state;
      }
  }
};

/**
 * Gets the dialog args for the specified dialogId
 * @param {any} state 
 * @param {string} dialogId 
 * @returns {any}
 */
var getDialogArgs = exports.getDialogArgs = function getDialogArgs(state, dialogId) {
  return state.get(dialogId);
};

/**
 * Gets the oldest dialog key from ordered map
 * @param {any} state 
 * @returns {string}
 */
var getFirstDialogKey = exports.getFirstDialogKey = function getFirstDialogKey(state) {
  var keys = state.keySeq().toArray();
  return keys && keys.length ? keys[0] : undefined;
};

/**
 * Gets the latest dialog key from ordered map
 * @param {any} state 
 * @returns {string}
 */
var getLastDialogKey = exports.getLastDialogKey = function getLastDialogKey(state) {
  var keys = state.keySeq().toArray();
  return keys && keys.length ? keys[keys.length - 1] : undefined;
};

exports.default = dialogReducer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/dialog/DialogReducer.js
// module id = 207
// module chunks = 10